<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h3 class="mb-0">{{ trans('owners.overview.title') }}</h3>
            <div class="d-flex align-items-end center gap-3">
                <small class="text-muted">{{
                    trans('owners.overview.results.count', {
                        total: owners.length,
                    })
                }}</small>

                <modal-link v-if="!isTablet && hasAnyPermission('owner.create')" :href="route('owners.create')">{{
                    trans('owners.overview.action.add')
                }}</modal-link>
            </div>
        </div>

        <div v-if="owners.length === 0">
            <card style="padding: 0 !important">
                <div class="text-gray text-center">
                    <div class="text-semi-bold">
                        {{ trans('stakeholders.overview.empty.owners.title') }}
                    </div>
                    <div>
                        {{ trans('stakeholders.overview.empty.description') }}
                    </div>
                </div>
            </card>
        </div>
        <div v-else>
            <card v-for="owner in owners" :key="owner.id" card-classes="mb-2" style="padding: 0 !important">
                <header class="d-flex justify-content-between align-items-center">
                    <h4 class="h6">{{ owner.name }}</h4>
                    <div v-if="!isTablet && hasAnyPermission(['owner.update', 'owner.delete'])" class="d-flex gap-1">
                        <modal-link
                            v-if="hasAnyPermission('owner.update')"
                            :href="route('owners.edit', owner)"
                            :tooltip="trans('general.action.edit')"
                            icon="cil-pencil"
                        />
                        <jet-button
                            v-if="hasAnyPermission('owner.delete')"
                            v-c-tooltip="{
                                content: trans('general.action.delete'),
                            }"
                            :destructive="true"
                            class="btn-icon"
                            type="button"
                            variant="secondary"
                            @click="deleteOwner(owner)"
                        >
                            <icon name="cil-trash" />
                        </jet-button>
                    </div>
                </header>
                <section>
                    <row>
                        <column lg="2" md="3">
                            <div class="whitespace-nowrap">
                                {{
                                    trans('stakeholders.overview.assets_count.label', {
                                        count: owner.assetsCount || 0,
                                    })
                                }}
                            </div>
                            <div class="whitespace-nowrap">
                                {{
                                    trans('stakeholders.overview.locations_count.label', {
                                        count: owner.topLevelLocationsCount || 0,
                                    })
                                }}
                            </div>
                        </column>
                        <column>
                            <stakeholder-contact-list :title="trans('owners.overview.contacts.title')" :contacts="owner.contacts" />
                        </column>
                    </row>
                </section>
            </card>
        </div>
    </div>
</template>
<script setup>
import JetButton from '@/Jetstream/Button.vue';
import { eventBus, events } from '@/eventBus.js';
import Card from '@/Components/Card.vue';
import { trans } from '@/mixins/i18n.js';
import { isTablet } from '@/Utils/UseMedia';
import { hasAnyPermission } from '@/mixins/hasAnyPermission.js';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import ModalLink from '@/Components/ModalLink.vue';
import StakeholderContactList from '@/Pages/Stakeholders/Components/StakeholderContactList.vue';

const page = usePage();
const owners = computed(() => page.props.owners?.data || []);

const deleteOwner = (item) => {
    eventBus.$emit(events.openConfirmDeleteStakeholderModal, {
        stakeholder: item,
        type: 'owner',
    });
};
</script>
